export default function IconArrow(props) {
  return (
    <svg
      className={`${props.className} fill-[currentColor]`}
      viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7194 6.38176L8.30035e-07 6.38176L7.32276e-07 8.61823L10.7194 8.61823L5.91882 13.4188L7.5 15L15 7.5L7.5 -3.27835e-07L5.91882 1.58118L10.7194 6.38176Z" />
    </svg>
  );
};
